export default __webpack_public_path__ + "static/media/pais.7942fd8a.png";